import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import { OrderIndListData, OrderIndFilter } from "../types";
import { loadAllOrderIndFloating } from "../thunks/loadAllOrderIndfloating";

export const useFloatingOrderIndData = (filter?: OrderIndFilter) => {
	const data = useSelector<StoreType, OrderIndListData[] | undefined>(
		s => s.data.trading.orderind.floatingData
	);

	const dispatch = useDispatch();

	const loadFloating = React.useCallback(
		() => dispatch(loadAllOrderIndFloating(filter)),
		[dispatch, filter]
	);

	return [
		data,
		loadFloating,
	] as [
		typeof data,
		typeof loadFloating
	];
};